import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "maxRedemptionsInputContainer", "unlimitedRedemptionsCheckbox" ]

  connect() {
    this.toggle();
  }

  toggle() {
    this.maxRedemptionsInputContainerTarget.classList.toggle("hidden", this.unlimitedRedemptionsCheckboxTarget.checked);
  }
}

